<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.441"
    height="18.427"
    viewBox="0 0 20.441 18.427"
  >
    <g transform="translate(-442.278 -358.521)">
      <path
        d="M452.454,376.948l-.345-.288c-.13-.109-3.214-2.686-4.443-3.993-.23-.245-.527-.527-.861-.845-1.451-1.381-3.644-3.468-4.268-6.11-.775-3.281.191-5.6,2.869-6.894,1.378-.668,3.063-.085,4.232.52a9.553,9.553,0,0,1,2.943,2.3c.818-1.205,2.666-3.8,6.018-2.856a5.42,5.42,0,0,1,3.966,6.54c-.035.144-.076.287-.124.429A15.547,15.547,0,0,1,457.807,372c-3.544,3.2-5.015,4.622-5.03,4.636Zm-5.679-17.422a2.136,2.136,0,0,0-.933.192c-2.231,1.077-2.993,2.963-2.332,5.764.556,2.352,2.619,4.316,3.984,5.616.35.332.659.628.9.884.953,1.014,3.165,2.9,4.014,3.623.612-.578,2.11-1.981,4.749-4.366a14.564,14.564,0,0,0,4.347-5.83c.027-.085.06-.2.088-.316a4.424,4.424,0,0,0-3.248-5.339c-2.749-.775-4.206,1.373-4.989,2.527-.348.513-.549.829-.97.736a.585.585,0,0,1-.448-.521,7.392,7.392,0,0,0-3.062-2.418A5.1,5.1,0,0,0,446.775,359.526Zm6.149,2.8-.493.082.493-.081Z"
        fill="#777"
      />
      <path
        d="M454.059,372.241H450.98v-2.823h-3.007v-3.3h3.007v-2.349h3.08v2.349h2.78v3.3h-2.78Zm-2.079-1h1.079v-2.823h2.78v-1.3h-2.78v-2.349h-1.08v2.349h-3.007v1.3h3.007Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
